import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { arrowBack } from "../../assets/svgs";
import styles from "./ui.module.scss";

export const GoBack = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <button
      className={styles.goBack}
      onClick={() => navigate(-1)}
      aria-label={t("return")}
    >
      {arrowBack.icon} {t("return")}
    </button>
  );
};
